import React from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux'
import {Modal, Button} from 'react-bootstrap';
import {addPath, redirectPage} from '../../common/utils';
import {LOG_IN_MESSAGE, URLs} from '../../common/constants';
import {showLoginSignupModal} from "../../actions/store/storeActions";
import ModalPopup from "../../components/common/ModalPopup";
import {translate} from "../../i18n/translate";

class LoginSignupModal extends React.Component {
    closePopup = () => {
        this.props.closePopup();
    }

    goToLogin = () => {
        this.closePopup();
        this.props.goToLogin()
    }

    goToCreateAccount = () => {
        this.closePopup();
        this.props.goToCreateAccount(this.props.staticData);
    }

    render() {
        if (!this.props.showPopup) {
            return null;
        }
        const isSupportGuestMembers = (this.props.staticData || {}).isSupportGuestMembers;
        if (isSupportGuestMembers) {
            return (
                <Modal className="modal-popup" show={true} onHide={this.closePopup}>
                    <Modal.Body>
                        <button className="modal-close-button" onClick={this.closePopup}/>
                        <div className="modal-message modal-message-horizontal">Ready to Checkout?</div>
                        <div className="one-button buttons-horizontal">
                            <Button id="modalButton" className="button" bsStyle="primary"
                                    onClick={this.goToCreateAccount}>Create Account</Button>
                        </div>
                        <div className="modal-message modal-message-horizontal">Already Have an Account?</div>
                        <div className="one-button buttons-horizontal">
                            <Button id="modalButton" className="button" bsStyle="primary"
                                    onClick={this.goToLogin}>Log In</Button>
                        </div>
                    </Modal.Body>
                </Modal>
            );
        }
        return (
            <ModalPopup
                onClose={this.closePopup}
                message={translate(LOG_IN_MESSAGE)}
                right={{text:translate('Log In'), callback:this.goToLogin}}
                left={{text:translate('Continue Browsing'), callback:this.closePopup}}/>
        )
    }
}

const mapStateToProps = (state) => {
    const orderStatus = state.orderStatus || {};
    return {
        staticData: state.staticData,
        showPopup: orderStatus.showLoginSignupModal,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        closePopup: () => {
            dispatch(showLoginSignupModal(false));
        },
        goToLogin: () => {
            dispatch(push(addPath('login')));
        },
        goToCreateAccount: (staticData) => {
            const joinURL = redirectPage(URLs.JOIN, staticData) + "?mode=guest";
            dispatch(() => window.location.assign(joinURL));
        }
    }
};

export default  connect(mapStateToProps, mapDispatchToProps)(LoginSignupModal);


// WEBPACK FOOTER //
// ./src/containers/common/LoginSignupModal.js